import { createRouter, createWebHashHistory } from "vue-router";

import MainRoutes from "@/views/index.js";
import SettingRoutes from "@/views/settings/index.js";
import DetailRoutes from "@/views/details/index.js";
import MockShoppingRoutes from "@/views/mock/shopping/index.js";
import MockInfluencerRoutes from "@/views/mock/influencer/index.js";
import ShoppingRoutes from "@/views/shopping/index.js";
import Shopping01Routes from "@/views/influencer/01/index.js";
import RegisterRoutes from "@/views/register/index.js";
import AdmissionRoutes from "@/views/admission/index.js";
import CartRoutes from "@/views/cart/index.js";
import Authenticate from "@/modules/Authenticate.js";

import Device from "@/modules/Device.js";
import Request from "@/modules/Request";
import Message from "@/modules/Message";

let authenticate = new Authenticate();
let device = new Device();
let request = new Request();


const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    ...SettingRoutes.routes,
    ...DetailRoutes.routes,
    ...MockShoppingRoutes.routes,
    ...MockInfluencerRoutes.routes,
    ...ShoppingRoutes.routes,
    ...Shopping01Routes.routes,
    ...RegisterRoutes.routes,
    ...AdmissionRoutes.routes,
    ...CartRoutes.routes,
    ...MainRoutes.routes,
  ],
});

router.beforeEach((to, from, next) => {
  // 画面遷移時はナビゲーションを閉じる
  document.querySelector("#menu-btn-check").checked = false;

  // ヘッダー＆フッターレイアウトを表示する
  // 伝票表示のときは全てのレイアウトを非表示にする
  window.app.$store.commit("showLayout");

  let ui0 = to.query.ui0;
  let ui1 = to.query.ui1;
  // let ui2 = to.query.ui2;
  let authToken = to.query.uu; // email, password認証をスキップするためのトークン
  let isMobileApp = to.query.isMobileApp; // モバイルアプリからの画面遷移

  if (!authToken && isMobileApp == "true") {
    // 旧アプリから画面遷移したものの、HtmlDecodeされていないので強引にuuを取得する
    let uu = to.query["amp;uu"];
    authToken = uu;
  }

  if (authToken) {
    authenticate.mobileAppLogin(authToken);
  }

  // MobileAppの場合は状態を維持する
  if (!device.isMobileApp() && isMobileApp) {
    device.setMobileApp(isMobileApp || false); // パラメータがなければ非アプリモード
  }

  if (ui0 && ui1) {
    let requestParams = request.createParams("webMdlMemberInfo", "updMailAddressLogin", [ui0, ui1]);
    request.create().post("", requestParams).then((data) => {
      Message.success().fire({
        position: 'center',
        showConfirmButton: true,
        timer: null,
        toast: false,
        title: data.msg,
      }).then(() => {
        if (data.isMobile) {
          location.href = 'https://appleach.page.link/76UZ';
        }
        else {
          next("/login");
        }
      });
    });
  }

  // rootアクセスは
  if ("/" == to.path) {
    if (authenticate.isLogin()) {
      next("/dashboard");
    } else {
      next("/login");
    }
    return;
  }

  // Loginが不要なurl
  let excludeURL = ["admission", "contact", "cancel", "serial", "login", "reminder", "register", "registration", "appsettings", "flora-anniversary", "reusebottle-refill", "msc-seminar", "msc-seminar-2023", "manavis-college", "manavis-college-entry", "foamingbodysoap", "settings/unregister/complete",
    "shopping", "shopping/serial", "shopping/serial/confirm", "shopping/serial/end", "shopping/serial/mail", "shopping/registration", "shopping/registration/confirm", "shopping/order", "shopping/order/confirm", "shopping/order/end", "shopping/order/mail", "thanks2023", "ouen2023", "starter2023",
    "mock/shopping", "mock/shopping/serial", "mock/shopping/serial/confirm", "mock/shopping/serial/end", "mock/shopping/serial/mail", "mock/shopping/registration", "mock/shopping/registration/confirm", "mock/shopping/order", "mock/shopping/order/confirm", "mock/shopping/order/end", "mock/shopping/order/mail",
    "mock/influencer", "mock/influencer/serial", "mock/influencer/serial/confirm", "mock/influencer/serial/end", "mock/influencer/serial/mail", "mock/influencer/registration", "mock/influencer/registration/confirm", "mock/influencer/order", "mock/influencer/order/confirm", "mock/influencer/order/end", "mock/influencer/order/mail", "/column/column-202306", "/column/column-202307", "/column/column-202308", "/column/column-202309", "/column/column-202310", "/column/column-202311", "/column/column-202312", "/column/column-202402", "/column/column-202403", "/column/column-202405", "/column/column-202407", "/column/column-202408", "/column/column-202410", "/column/column-202411", "/column/column-202412", "/column/column-202501", "/column/column-202502", "/column/column-202503", "/column/column-202504", "/column/column-202505", "/column/column-202506", "/column/column-2025special", "/column/column-202509", "/column/column-202509-2", "/column/column-202510", "/column/column-202601", "/lp/manavisfesta2024", "/lp/manavisfesta202505", "/lp/omotenashiselection2024", "/lp/supplementplus202501", "/lp/homeicon-iphone", "/lp/homeicon-android", "/lp/vitamin-d-plus", "/app-end-of-service"];

  // ログイン対象外のURLかを判定
  let isExclude = false;
  excludeURL.forEach((url) => {
    if (to.path.indexOf(url) > -1) {
      isExclude = true;
    }
  });
  if (isExclude) {
    next();
  } else {
    if (!authenticate.isLogin()) {
      // ログインしていなければLogin画面へ遷移
      Message.error().fire({
        title: "会員サイトを利用するにはログインしてください"
      }).then((/*result*/) => {
        next("/login");
      });
    } else {
      next();
    }
  }
});

export default router;
